import { Tag } from 'antd';
import React from 'react';

export const getStatusTag = (status: string): React.ReactElement => {
  const statusMap = {
    instructions_shown: { color: 'cyan', text: 'Instrukcje pokazane' },
    waiting_for_code: { color: 'orange', text: 'Oczekuje na kod' },
    code_expired: { color: 'volcano', text: 'Kod wygasł' },
    code_provided: { color: 'blue', text: 'Kod wysłany' },
    awaiting_user_response: { color: 'gold', text: '⏰ Modal użytkownika' },
    user_inactive: { color: 'magenta', text: '💤 Użytkownik nieaktywny' },
    completed: { color: 'green', text: 'Zatwierdzone' },
    rejected: { color: 'red', text: 'Odrzucone' },
  };
  const config = statusMap[status] || { color: 'default', text: status };
  return React.createElement(Tag, { color: config.color }, config.text);
};
